
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anonymous-assessments/[anonymousId]",
      function () {
        return require("private-next-pages/anonymous-assessments/[anonymousId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anonymous-assessments/[anonymousId]"])
      });
    }
  